module.exports = __webpack_public_path__ + "img/investBg-m-mp.e4e2bbf0.png";